
import "./index.scss";
import Layout from "../../components/mainPage/Layout";
// import ProductComparison from "shared/components/ProductComparison";
import { IntroTab, getVersion } from "../../components/mainPage/intro/IntroTab";
import React, { useContext } from "react";
import admInt from "../../images/admininterface.png";
import prodInt from "../../images/prodinterface.png";
import developInt from "../../images/developerinterface.png";
import Advantages from "shared/components/Advantages";
import station from "shared/icons/station.png"
import generation from "shared/icons/generation.png"
import alternative from "shared/icons/alternative.png"
import ras from "shared/icons/ras.png"
import factory from "shared/icons/factory.png"
import transport from "../../images/icons/transport.svg";
// import transport from "../../images/icons/industry.svg";
import AutomationSection from "shared/components/AutomationSection";
import { AppRoute } from "../../constants";
import { BackgroundSection } from "shared/components/BackgroundSection";
import { ClientOnly } from "shared/components/ClientOnly";
import { Link } from "shared/components/Link";

export function Page() {
  const version = getVersion()
  let active = 2
  if (version == 'expert') {
    active = 1
  }
  const changeActive = (idx) => {
    const plus = idx == 1 ? 'false' : 'true'
    const params = new URLSearchParams(window.location.search);
    params.set('plus', plus);
    window.location.search = params.toString();
  }
  const fallback = React.useCallback(() => <></>, [])
  const component = React.useCallback(() => import("shared/components/ProductComparison"), [])
  return (
    <Layout>
      <main className="main-page">
        <IntroTab />
        <Advantages columns={advantages} />
        <AutomationSection
          data={automationColumns}
        />
        <ClientOnly
          component={component}
          props={{
            active, links: LINKS, changeActive, features: FEATURES, products: PRODUCTS
          }}
          fallback={fallback}
        />
        <BackgroundSection />
      </main>
    </Layout>
  );
}
//export const doNotPrerender = = false


const automationColumns = [
  {
    title: "Подстанции",
    paragraph:
      "Автоматизация технологических процессов магистральных и распределительных подстанций",
    color: "rgb(41 117 219)",
    image: station,
    link: AppRoute.AutomationStation,
  },
  {
    title: "Генерация",
    paragraph:
      "Автоматизация технологических процессов тепловых, атомных и гидроэлектростанций",
    color: "#F4D1AA",
    image: generation,
    link: AppRoute.AutomationGeneration,
  },
  {
    title: "Альтернативная генерация",
    paragraph:
      "Автоматизация технологических процессов ветряных и солнечных электростанций",
    color: "rgb(18 34 57)",
    image: alternative,
    link: AppRoute.AutomationAlternativeGeneration,
  },
  {
    title: "Диспетчерское управление электросетями",
    paragraph:
      "Оперативно-технологическое и диспетчерское управление электрическими сетями (DMS/OMS/EMS/FLISR)",
    color: "rgb(41 117 219)",
    image: ras,
    link: AppRoute.AutomationDispatchControl,
    isExpert: true,
  },
  {
    title:
      "Диспетчерское управление электроснабжением промышленного предприятия",
    paragraph:
      "Диспетчерское управление технологическими процессами и автоматизация технического учета энергоресурсов промышленных предприятий",
    color: "#F4D1AA",
    image: factory,
    link: AppRoute.AutomationPowerSupply,
    isExpert: true,
  },
  {
    title: "Транспорт",
    paragraph:
      "Автоматизация технологических процессов для объектов транспортной инфраструктуры, трубопроводов и сопутствующих сооружений",
    color: "rgb(18 34 57)",
    image: transport,
    link: AppRoute.Transport,
    isExpert: true,
  },
]

const advantages = [
  {
    id: 1,
    image: prodInt,
    title: "Интерфейс оператора",
    paragraph:
      "Управляйте технологическими процессами предприятия",
  },
  {
    id: 2,
    image: admInt,
    title:
      "Интерфейс администратора системы",
    paragraph:
      "Управляйте учетными записями и контролируйте состояние ресурсов сервера",
  },
  {
    id: 3,
    image: developInt,
    title: "Интерфейс разработчика",
    paragraph:
      "Разрабатывайте собственные проекты автоматизации технологического процесса",
  },
];
const LINKS = [
  { type: "href", href: "https://scada-npt-compact.ru/" },
  { type: "version", version: "expert" },
  { type: "version", version: "plus" },
];
export const FEATURES = [
  {
    label: "Базовый пакет",
    description: `Поддержка протоколов: Modbus, IEC 60870-5-104 Client;\n
Архивирование: Postgres/SQLite;\n
Web-клиенты: Неограничено;\n
Desktop приложение: 1 рабочее место.`,
    values: ["до 100 устройств", "больше 100", "больше 100"],
  },
  {
    label: "Клиенты",
    items: [
      {
        label: "Desktop Application",
        description: "Desktop приложение (дополнительное рабочее место)",
        values: [false, true, true],
      },
      {
        label: "Multimonitor Desktop Application",
        description:
          "Возможность объединения нескольких экранов (4 и более) (для одного рабочего места)",
        values: [false, false, true],
      },
      {
        label: "Touch Panel Application",
        description:
          "Embedded версия для панелей с touch screen (для одной графической панели)",
        values: [true, false, true],
      },
      {
        label: "NPT Mobile",
        description:
          "Embedded версия для панелей с touch screen (для одной графической панели)",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Автоматизация и логическая обработка",
    items: [
      {
        label: "Report builder",
        description: "Конструктор отчетов",
        values: [true, true, true],
      },
      {
        label: "IEC 61131",
        description: "Свободно-программируемая логика МЭК 61131 ST и FBD",
        values: [true, true, true],
      },
      {
        label: "Cron tasks",
        description: "Периодические задачи/выполнение задач по расписанию",
        values: [true, true, true],
      },
      {
        label: "Switching plan editor",
        description: "Редактор автоматических и автоматизированных бланков переключений",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Протоколы передачи данных",
    items: [
      {
        label: "МЭК 61850 Клиент",
        description: "Подключение устройств по МЭК 61850",
        values: [true, true, true],
      },
      {
        label: "МЭК 61850 Сервер",
        description: "Передача данных МЭК 61850-90-2",
        values: [true, true, true],
      },
      {
        label: "МЭК 60870-5-104 Сервер",
        description: "Передача данных МЭК 60870-5-104",
        values: [true, true, true],
      },
      {
        label: "MQTT Клиент",
        description:
          "Возможность приема/передачи данных в брокеры сообщений MQTT",
        values: [true, false, false],
      },
      {
        label: "RabbitMQ Клиент",
        description:
          "Возможность приема/передачи данных в брокер сообщений, который поддерживает множество протоколов (включая AMQP, MQTT , STOMP, HTTP и др.)",
        values: [true, false, false],
      },
      {
        label: "Kafka Клиент",
        description:
          "Возможность приема/передачи данных в брокеры сообщений Kafka",
        values: [true, false, false],
      },
      {
        label: "SNMP Клиент",
        description: "Сбор данных мониторинга сетевых устройств",
        values: [false, true, true],
      },
      {
        label: "SMTP Клиент",
        description: "Возможность отправки уведомлений, оповещений и отчетов по электронной почте",
        values: [true, true, true],
      },
      {
        label: <><Link to={'/sksu'}>СКСУ</Link> клиент</>,
        description: "Взаимодействие SCADA NPT и ПО СКСУ",
        values: [false, true, true],
      },


      {
        label: "OPC UA Client",
        description: "Подключение к OPC UA Server с помощью стандартного протокола OPC UA",
        values: [true, true, true],
      },
      {
        label: "OPC UA Server",
        description: "Источник данных для других устройств и систем, предоставляемых по правилам OPC UA",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Графические плагины",
    items: [
      {
        label: "Просмотровщик осциллограмм",
        description: "Просмотр и анализ  осциллограм",
        values: [false, true, true],
      },
      {
        label: "Интерактивная географическая карта",
        description: "Интеграция с ГИС",
        values: [false, false, true],
      },

      {
        label: "Video Plugin",
        description: "Отображение информации с видеокамер",
        values: [false, false, true],
      },
    ],
  },
  {
    label: "Опции для электроэнергетики на базе CIM",
    link: { title: "NPT Platform", href: "https://npt-platform.ru/" },
    items: [
      {
        label: "Topology service",
        description: "Топологический анализ",
        values: [false, false, true],
      },
      {
        label: "Powerflow service",
        description: "Расчет режима",
        values: [false, false, true],
      },

      {
        label: "State estimation service",
        description: "Оценивание состояния",
        values: [false, false, true],
      },
      {
        label: "Short circuit service",
        description: "Расчет ТКЗ",
        values: [false, false, true],
      },
      {
        label: "Dispatcher simulator",
        description: "Тренажер диспетчера",
        values: [false, false, true],
      },
      {
        label: "Switching plan",
        description: "Динамический бланк переключений",
        values: [false, false, true],
      },
    ],
  },
  {
    label: "Интегрированная среда параметрирования",
    link: { title: "SCADA Studio", href: `https://scada-npt-expert.ru/scadastudio/` },
    items: [
      {
        label: "Поддержка проекта в виде SCD файла",
        values: [null, true, true],
      },
      {
        label: "Интеграция контроллеров присоединения NPT",
        values: [null, true, true],
      },

      {
        label: "Интеграция СКСУ",
        values: [null, true, true],
      },
      {
        label: "Поддержка логики на всех языках МЭК 61131",
        values: [null, true, true],
      },
    ],
  },
];

export const PRODUCTS = [
  "SCADA NPT Compact",
  "SCADA NPT Expert",
  "SCADA NPT Expert Plus",
];
